import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SignIn from "../auth/signin/signin";
import SideBarProfile from "../SideBarLeft/userSideBar/sidebarProfile";
import TopGuildSideBarLeft from "../SideBarLeft/guild/topGuild";
import CsWinners from "../SideBarLeft/csWinners/csWinners";
import Center from "../centerPages/center";
import OwnersSideBarRight from "../SideBarRight/owners/OwnersSideBarRight";
import Top10Players from "../SideBarRight/top10players/top10players";
import DiscordWidget from "../SideBarRight/Discord/discord";
import Hero from "../home/Hero";
import {
  ServerStatus,
  UpcomingEventsPanel,
  PlayerStatsPanel,
  FeaturedItem,
  GalleryPanel,
  NewsPanel,
} from "../home/homePanels";
import "./Dashboard.scss";

const Dashboard = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const hidePageSidebar = location.pathname.startsWith("/guides");
  const isProfilePage = location.pathname === "/profile";
  const userAuth = useSelector((state) => state.reducerUser.userLogin);
  const isAuthed = userAuth?.status === "fulfilled";

  if (!isHome) {
    return (
      <div
        className={`mu-dashboard mu-dashboard--page${
          hidePageSidebar ? " mu-dashboard--page-noside" : ""
        }${isProfilePage ? " mu-dashboard--profile" : ""}`}
      >
        {hidePageSidebar ? null : (
          <aside className="mu-dashboard__side">
            {isAuthed ? <SideBarProfile user={userAuth} /> : <SignIn />}
            <div className="mu-dashboard__page-staff">
              <OwnersSideBarRight />
            </div>
          </aside>
        )}
        <main className="mu-dashboard__main">
          <Center />
        </main>
      </div>
    );
  }

  /*
    Desktop:
      LEFT:   Discord → Castle Siege → Featured
      CENTER: News → Top Players → Gallery → Top Guilds
      RIGHT:  Server Status → Staff → Login → Events → Player Stats
    Mobile stack order:
      RIGHT rail first (Server Status…), then Hero, then left/center.
  */
  return (
    <div className="mu-dashboard mu-dashboard--home">
      <div className="mu-dashboard__hero">
        <Hero />
      </div>

      <aside className="mu-dashboard__rail" aria-label="Server sidebar">
        <ServerStatus />
        <OwnersSideBarRight />
        {isAuthed ? <SideBarProfile user={userAuth} /> : <SignIn />}
        <UpcomingEventsPanel />
        <PlayerStatsPanel />
      </aside>

      <div className="mu-dashboard__primary">
        <div className="mu-dashboard__content">
          <div className="mu-dashboard__left">
            <DiscordWidget />
            <CsWinners />
            <FeaturedItem />
          </div>

          <div className="mu-dashboard__center">
            <NewsPanel />
            <Top10Players />
            <GalleryPanel />
            <TopGuildSideBarLeft />
          </div>
        </div>

        <div className="mu-dashboard__below mu-dashboard__below--home-hidden">
          <Center />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
